import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=76cb385a&scoped=true"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb385a",
  null
  
)

export default component.exports